import { render, staticRenderFns } from "./PaymentSalesmanArea.vue?vue&type=template&id=20eff239&scoped=true"
import script from "./PaymentSalesmanArea.vue?vue&type=script&lang=js"
export * from "./PaymentSalesmanArea.vue?vue&type=script&lang=js"
import style0 from "./PaymentSalesmanArea.vue?vue&type=style&index=0&id=20eff239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eff239",
  null
  
)

export default component.exports